// extracted by mini-css-extract-plugin
module.exports =  {"tabWrapper":"tabWrapper___iv7Yf","photoWrapper":"photoWrapper___vv5sd","textWrapper":"textWrapper___xB49I"};